import React from 'react';
import blueTray from '@assets/images/icons/blueTray.svg';
import styles from './index.module.scss';

interface NoDataBlueTrayProps {
  text: string;
}

export const NoDataBlueTraySection: React.FC<NoDataBlueTrayProps> = ({ text }) => (
  <div className={styles.noFocusContainer}>
    <img src={blueTray} className={styles.blueTray} alt="blue tray" />
    <p className={styles.noChosenAreaText}>{text}</p>
  </div>
);
